
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[mainSubpage]/[subcategory]/[id]",
      function () {
        return require("private-next-pages/[mainSubpage]/[subcategory]/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[mainSubpage]/[subcategory]/[id]"])
      });
    }
  